import { MerchLandingComponent } from './merch-landing.component';

export const components: any[] = [
	MerchLandingComponent
];

export * from './merch-landing.component';
